import { css } from 'styled-components';

export const ionVerticalGradientText = css`
  font-size: 32px;

  background: linear-gradient(180deg, #BED8E6 0%, #9DB9C8 35%, #7A9DAC 70%, #5A8A9D 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;
